import React, { useState } from "react";
import { Typography, Box, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setReviewActiveStep, setActiveStep } from "../../new-booking-form.slice";
import TextFieldInput from "../../../../components/TextFieldInput";
import SnackbarAlert from "../../../../shared-components/snackbar-alert/SnackbarAlert";
import CommonButton from "../../../../shared-components/common-button/CommonButton";
import editIcon from "../../../../assets/icons/ic-solar_pen-bold.svg";
import "../style.scss";

const AuthorizedSignatoryDetailsReview = () => {
  const dispatch = useDispatch();
  const { applicantData, reviewActiveStep } = useSelector(
    (state) => state?.newBookingForm
  );

  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSnackbarClose = () => {
    setSnackbarConfig({ open: false, message: "", severity: "" });
  };
  // extract authorized signatories (up to 4 applicants)
  const companyDataList = [];
  for (let i = 1; i <= 4; i++) {
    const applicant = applicantData?.[`applicant${i}`];
    if (applicant) {
      companyDataList.push({
        firstName: applicant?.personalDetails?.firstName || "",
        lastName: applicant?.personalDetails?.lastName || "",
        email: applicant?.personalDetails?.emailAddress || "",
        contactNumber: applicant?.personalDetails?.contactNumber || "",
        panNumber: applicant?.personalDetails?.panNumber || "",
        aadharNumber: applicant?.personalDetails?.aadhaarNumber || "",
      });
    }
  }

  const handleSaveForm = () => {
    dispatch(setReviewActiveStep(reviewActiveStep + 1));
  };
  const handlePrevious = () => {
    dispatch(setReviewActiveStep(reviewActiveStep - 1));
  };

  return (
    <div className="companyDetailsContainer">
      <Box
        sx={{
          maxHeight: 500,
          overflowY: "auto",
          overflowX: "hidden",
          pr: 1,
        }}
      >
        {companyDataList?.map((company, index) => (
          <Box
            key={`${company?.email ?? ""}-${company?.panNumber ?? ""}-${index}`}
            sx={{
              mb: 4,
              p: 2,
              border: "1px solid #ddd",
              borderRadius: 2,
              backgroundColor: "#fafafa",
              position: "relative",
            }}
          >
            <IconButton
              size="small"
              onClick={() => dispatch(setActiveStep(index +  2))}
              className="editIcon"
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <img src={editIcon} alt="edit" style={{ width: 16, height: 16 }} />
            </IconButton>

            {/* Heading */}
            <Typography
              variant="h6"
              gutterBottom
              align="center"
              sx={{ fontSize: "14px", fontWeight: 500 }}
            >
              Authorized Signatory {index + 1}
            </Typography>

            {/* Row 1: First + Last Name */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextFieldInput
                field={{
                  label: "First Name",
                  readonly: true,
                  value: company.firstName,
                }}
              />
              <TextFieldInput
                field={{
                  label: "Last Name",
                  readonly: true,
                  value: company.lastName,
                }}
              />
            </Box>

            {/* Row 2: Contact Number + Email */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextFieldInput
                field={{
                  label: "Contact Number",
                  readonly: true,
                  value: company.contactNumber,
                }}
              />
              <TextFieldInput
                field={{
                  label: "Email Address",
                  readonly: true,
                  value: company.email,
                }}
              />
            </Box>

            {/* Row 3: PAN + Aadhaar */}
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextFieldInput
                field={{
                  label: "PAN Number",
                  readonly: true,
                  value: company.panNumber || "—",
                }}
              />
              <TextFieldInput
                field={{
                  label: "Aadhaar Number",
                  readonly: true,
                  value: company.aadharNumber || "—",
                }}
              />
            </Box>
          </Box>
        ))}

        <CommonButton
          type="button"
          handleNext={handleSaveForm}
          handlePrevious={handlePrevious}
          saveForLater={false}
        />

        <SnackbarAlert
          open={snackbarConfig.open}
          message={snackbarConfig.message}
          severity={snackbarConfig.severity}
          onClose={handleSnackbarClose}
        />
      </Box>
    </div>
  );
};

export default AuthorizedSignatoryDetailsReview;
